import e from"styled-components";const t=e.div`
	display: flex;
	flex-direction: column;
	align-self: stretch;
	padding: 8px;
	gap: 16px;
	height: 100%;
	box-sizing: border-box;
	justify-content: space-between;
`,i=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`,l=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,p=e.img`
	width: ${({isTemplate:e})=>e?"21px":"40px"};
	height: ${({isTemplate:e})=>e?"21px":"40px"};
	border-radius: 4px;
	object-fit: cover;
`;e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: 8px;
`,e.div`
	background: #999;
	width: 13px;
	height: 1px;
`;const o=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"14px":"22px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"16px":"25.887px"};
`,n=e.div`
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"9px":"14px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"11.974px":"18px"};

	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,x=e.div`
	display: flex;
	align-items: baseline;
	gap: 0px 6px;
	align-self: stretch;
	align-items: center;
	flex-wrap: wrap;
	color: ${({theme:e})=>e.text.text};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};

	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`,a=e.div`
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`;export{a as Author,t as CardContent,l as CardMiddleContent,i as CardTopContent,x as CreatedByWrapper,n as Description,p as SpaceAvatar,o as Title};
